export const syncOrders = () => ({
    type: 'SYNC_ORDERS',
})

export const syncLoadingTrue = () => ({
    type : 'SYNC_LOADING_TRUE'
});

export const syncLoadingFalse = () => ({
    type : 'SYNC_LOADING_FALSE'
});

export const onSyncSuccess = payload => ({
    type: 'SYNC_ORDERS_SUCCESS',
    payload,
})

export const onSyncFailure = payload => ({
    type: 'SYNC_ORDERS_FAILURE',
    payload,
})

export const onOk = () => ({
    type: 'ON_OK_SYNC',
})



// WEBPACK FOOTER //
// ./src/actions/syncAction.js